import { Button } from '@1trading/react/components/ui/button';
import { GradientIcon } from '@1trading/react/components/ui/gradient-icon';
import { CircleCheck } from 'lucide-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { PageHeading, PageHeadingDescription, PageHeadingTitle } from '@/components/ui/page-heading';
import { useProfilePeriodicReviewConfirmation } from '@/hooks/queries/use-profile-periodic-review';
import { useProfileVerificationInformation } from '@/hooks/queries/use-profile-verification-information';
import BaseLayout from '@/layouts/base';
import LoadingPage from '@/pages/loading';

const REDIRECT_DELAY_MS = 5_000;

const PeriodicReviewCompletePage = () => {
  const { isLoading: isLoadingConfirmation, data: confirmation } = useProfilePeriodicReviewConfirmation();
  const { isLoading: isLoadingVerificationInformation, data: verificationInformation } = useProfileVerificationInformation();
  const { t } = useTranslation();
  // Customers arrive here on submitting to Sumsub, before its result
  const isCheckingDocuments = !!confirmation?.verificationSteps.length && verificationInformation?.verification.status !== 'VERIFICATION_SUCCEEDED';

  useEffect(() => {
    const timeout = setTimeout(() => {
      window.location.assign(import.meta.env.VITE_APP_EXCHANGE_URL);
    }, REDIRECT_DELAY_MS);

    return () => clearTimeout(timeout);
  }, []);

  if (isLoadingConfirmation || isLoadingVerificationInformation) return <LoadingPage />;

  return (
    <BaseLayout className="-md:justify-center space-y-8" size="sm">
      <GradientIcon className="size-32 mx-auto" strokeWidth={1.5}>
        <CircleCheck />
      </GradientIcon>
      <PageHeading centered>
        <PageHeadingTitle>{t('periodicReview.complete.title')}</PageHeadingTitle>
        <PageHeadingDescription>{t(isCheckingDocuments ? 'periodicReview.complete.checkingDocuments' : 'periodicReview.complete.description')}</PageHeadingDescription>
        <PageHeadingDescription>{t('onboardingProgress.complete.redirecting')}</PageHeadingDescription>
      </PageHeading>
      <Button size="lg" variant="primary" asChild>
        <a href={import.meta.env.VITE_APP_EXCHANGE_URL}>{t('buttons.continue')}</a>
      </Button>
    </BaseLayout>
  );
};
PeriodicReviewCompletePage.displayName = 'PeriodicReviewCompletePage';

export default PeriodicReviewCompletePage;
